import {
    SETUP_STRIPE_INTENT_SUCCESSFUL,
    SET_ADYEN_3DS_ACTION,
    SET_ADYEN_3DS_REQUIRED,
    REQUEST_ADYEN_SYNCHRONIZE_SUCCESSFUL,
    RESET_STRIPE_CLIENT_SECRET,
    RESET_STRIPE,
    GET_PUB_KEY_SUCCESS,
    GET_PUB_KEY_INTENT_SUCCESSFUL,
    SET_PAYMENT_PROVIDER,
    SET_DEFAULT_LOCALE,
    SET_API_CONFIG,
    SET_ADYEN_SESSION,
    CLEAR_ADYEN_SESSION,
    SET_ADYEN_SESSION_ERROR,
} from './types';

const initState = {
    paymentProvider: '',
    stripe: {
        pubKey: '',
        clientSecret: '',
    },
    adyen: {
        // Legacy "advanced flow" fields — still used by booking-time payment-intent
        // 3DS path (src/sagas/bookings/createSBRequest.js). Do not remove without
        // migrating that flow.
        nextAction: {},
        status3ds: '',
        is3dsRequired: null,
        pubKey: '',
        // Sessions flow (ISJ-8831) — setup-intent session driving AdyenCheckout.
        session: null,           // { id, sessionData, clientKey, returnURL } | null
        sessionError: null,      // Error | null
    },
    defaultLocale: '',
    apiConfig: {},
};

const reducer = (state = initState, { type, payload }) => {
    switch (type) {
        case RESET_STRIPE: {
            return {
                ...initState,
                defaultLocale: state.defaultLocale,
                apiConfig: state.apiConfig,
            };
        }

        case RESET_STRIPE_CLIENT_SECRET: {
            return {
                ...state,
                stripe: {
                    ...state.stripe,
                    clientSecret: '',
                },
            };
        }

        case SETUP_STRIPE_INTENT_SUCCESSFUL: {
            const { pubKey, clientSecret, setupIntentId } = payload;
            return {
                ...state,
                stripe: {
                    clientSecret,
                    pubKey: pubKey !== undefined ? pubKey : state.stripe.pubKey,
                    setupIntentId,
                },
            };
        }

        case SET_ADYEN_3DS_REQUIRED: {
            const { is3dsRequired } = payload;
            return {
                ...state,
                adyen: {
                    ...state.adyen,
                    is3dsRequired,
                },
            };
        }

        case SET_ADYEN_3DS_ACTION: {
            const { nextAction } = payload;
            return {
                ...state,
                adyen: {
                    ...state.adyen,
                    nextAction,
                },
            };
        }

        case REQUEST_ADYEN_SYNCHRONIZE_SUCCESSFUL: {
            return {
                ...state,
                adyen: {
                    ...state.adyen,
                    status3ds: payload,
                },
            };
        }

        case GET_PUB_KEY_SUCCESS: {
            const { pubKey } = payload;
            return {
                ...state,
                stripe: {
                    clientSecret: '',
                    pubKey,
                },
            };
        }

        case GET_PUB_KEY_INTENT_SUCCESSFUL: {
            const { pubKey } = payload;
            return {
                ...state,
                adyen: {
                    ...state.adyen,
                    pubKey,
                },
            };
        }

        case SET_ADYEN_SESSION: {
            return {
                ...state,
                adyen: {
                    ...state.adyen,
                    session: payload,
                    sessionError: null,
                },
            };
        }

        case CLEAR_ADYEN_SESSION: {
            return {
                ...state,
                adyen: {
                    ...state.adyen,
                    session: null,
                    sessionError: null,
                },
            };
        }

        case SET_ADYEN_SESSION_ERROR: {
            return {
                ...state,
                adyen: {
                    ...state.adyen,
                    session: null,
                    sessionError: payload,
                },
            };
        }

        case SET_PAYMENT_PROVIDER: {
            return {
                ...state,
                paymentProvider: payload,
            };
        }

        case SET_DEFAULT_LOCALE: {
            return {
                ...state,
                defaultLocale: payload,
            };
        }

        case SET_API_CONFIG: {
            return {
                ...state,
                apiConfig: {
                    ...state.apiConfig,
                    ...payload,
                },
            };
        }

        default:
            return state;
    }
};

export default reducer;
